export default __webpack_public_path__ + "static/media/Machinery Red.d69666d0.png";